import type { FC } from 'react';
import ClockIcon from '@ordr-as/icons/ClockIcon';
import type { SectionNextOpen } from '../../utils/openingHours';

interface Props {
  sectionId: string | undefined;
  zoneId: string;
  nextOpen: SectionNextOpen | undefined;
}

function formatWeekday(day: string): string {
  return day.charAt(0) + day.slice(1).toLowerCase();
}

function scheduleFor(nextOpen: SectionNextOpen): string {
  switch (nextOpen.kind) {
    case 'opensToday': {
      return `opens today at ${nextOpen.time}`;
    }
    case 'opensTomorrow': {
      return `opens tomorrow at ${nextOpen.time}`;
    }
    case 'opensWeekday': {
      return `opens ${formatWeekday(nextOpen.day)} at ${nextOpen.time}`;
    }
    case 'closedIndefinitely': {
      return 'currently closed';
    }
  }
}

function messageFor(nextOpen: SectionNextOpen): string {
  if (nextOpen.kind === 'closedIndefinitely') {
    return 'Currently closed.';
  }
  return `Closed. ${scheduleFor(nextOpen).charAt(0).toUpperCase()}${scheduleFor(nextOpen).slice(1)}.`;
}

const OutsideOpeningHoursBanner: FC<Props> = ({ sectionId, zoneId: _zoneId, nextOpen }) => {
  if (!sectionId || !nextOpen) {
    return null;
  }

  return (
    <div className="bg-brand-accent p-2 my-2 rounded text-sm leading-5">
      <div className="flex flex-row items-center">
        <ClockIcon className="mr-2" />
        {messageFor(nextOpen)}
      </div>
    </div>
  );
};

export default OutsideOpeningHoursBanner;
